/**
 * Image gallery component used on ResourcePage banner
 * @see ResourcePage
 */
const Gallery = () => {
    const galleryItems = document.querySelectorAll(".js-gallery-item");
    const mainImage = document.querySelector(".js-gallery-main");

    if (!galleryItems.length && mainImage) {
        return false;
    }

    galleryItems.forEach((item) => {
        item.addEventListener("click", () => {
            // get inner image
            const image = item.querySelector(".js-gallery-image");

            // remove current class from all wrappers
            galleryItems.forEach((thumb) =>
                thumb.classList.remove("c-gallery__thumbnail--current")
            );

            item.classList.add("c-gallery__thumbnail--current");

            // Set main gallery image src with current selected thumbnail
            mainImage.setAttribute("src", image.getAttribute("data-src"));
        });
    });
};

export default Gallery;
